/* Releases below-the-fold images (snippets/custom-deferred-image.liquid) once the page has loaded,
   or on the first scroll or tap if that comes sooner, so they don't compete with the hero. */
(() => {
  if (window.garrnishDeferredImages) return;
  window.garrnishDeferredImages = true;
  const EVENTS = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
  const release = () => {
    EVENTS.forEach((type) => window.removeEventListener(type, release));
    document.querySelectorAll('img[data-deferred-src]').forEach((img) => {
      if (img.dataset.deferredSrcset) img.srcset = img.dataset.deferredSrcset;
      img.src = img.dataset.deferredSrc;
      img.removeAttribute('data-deferred-srcset');
      img.removeAttribute('data-deferred-src');
    });
  };
  if (window.Shopify?.designMode) {
    release();
    document.addEventListener('shopify:section:load', release);
    return;
  }
  EVENTS.forEach((type) => window.addEventListener(type, release, { passive: true }));
  if (document.readyState === 'complete') release();
  else window.addEventListener('load', release, { once: true });
})();
